var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32812 0.84375C6.5625 0.328125 7.07812 0 7.64062 0H13.3125C13.875 0 14.3906 0.328125 14.625 0.84375L15 1.5H19.5C20.2969 1.5 21 2.20312 21 3C21 3.84375 20.2969 4.5 19.5 4.5H1.5C0.65625 4.5 0 3.84375 0 3C0 2.20312 0.65625 1.5 1.5 1.5H6L6.32812 0.84375ZM1.45312 6H19.5V21C19.5 22.6875 18.1406 24 16.5 24H4.45312C2.8125 24 1.45312 22.6875 1.45312 21V6ZM5.20312 9.75V20.25C5.20312 20.6719 5.57812 21 5.95312 21C6.375 21 6.70312 20.6719 6.70312 20.25V9.75C6.70312 9.375 6.375 9 5.95312 9C5.57812 9 5.20312 9.375 5.20312 9.75ZM9.70312 9.75V20.25C9.70312 20.6719 10.0781 21 10.4531 21C10.875 21 11.25 20.6719 11.25 20.25V9.75C11.25 9.375 10.875 9 10.4531 9C10.0781 9 9.70312 9.375 9.70312 9.75ZM14.25 9.75V20.25C14.25 20.6719 14.5781 21 15 21C15.375 21 15.75 20.6719 15.75 20.25V9.75C15.75 9.375 15.375 9 15 9C14.5781 9 14.25 9.375 14.25 9.75Z",
    fill: "#F67924"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/drop.d08655c87fb0993de3bb24166830526c.svg";
export { ForwardRef as ReactComponent };